<template>
  <div class="job-location-editor">
    <div v-show="localJobLocationList && localJobLocationList.length > 0" class="job-location-list">
      <draggable
        v-model="localJobLocationList"
        handle=".draggable-handle"
        animation="300"
        ghostClass="ghost"
        :disabled="disabled"
        @change="handleDraggableChange"
      >
        <div
          v-for="(location, index) in localJobLocationList"
          class="job-location"
          :class="disabled && 'disabled'"
          :key="location._vid"
        >
          <i class="iconfont iconMore draggable-handle"></i>
          <span class="city">{{ location.city.i18nName }}</span>
          <span class="region-cbd">
            <span v-if="location.region">{{ location.region.i18nName }}</span>
            <span v-if="location.cbd">, {{ location.cbd.i18nName }}</span>
          </span>
          <span class="address">{{ location.address }}</span>
          <div v-if="!location.companyLocationId" class="edit-btn" @click="handleEditBtnClick(location, index)">
            <i class="el-icon-edit"></i>
          </div>
          <div class="delete-btn" @click="handleDeleteBtnClick(location, index)">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </draggable>
    </div>
    <div class="location-btn-group">
      <el-button class="location-btn select-btn" type="text" @click="handleSelectBtnClick">+ {{ $t(`${i18nPrefix}.btn.selectLocation`) }}</el-button>
      <el-button class="location-btn add-btn" type="text" @click="handleAddBtnClick">+ {{ $t(`${i18nPrefix}.btn.addLocation`) }}</el-button>
    </div>
    <LocationSelectorDialog
      class="list-dialog"
      :show.sync="listDialog.show"
      :company-id="companyId"
      :selected="listDialog.selected"
      @change="handleSelectedLocationChanged"
    />
    <LocationEditorDialog
      class="editor-dialog"
      :show.sync="editorDialog.show"
      :value="editorDialog.location"
      @change="handleEditLocationChanged"
    />
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
import _ from 'lodash'
import { addI18nProperty } from '@/i18n'
import LocationSelectorDialog from './locationSelectorDialog.vue'
import LocationEditorDialog from './locationEditorDialog.vue'
import draggable from 'vuedraggable'

export default {
  mixins: [emitter],
  components: {
    draggable,
    LocationSelectorDialog,
    LocationEditorDialog
  },
  model: {
    prop: 'jobLocationList',
    event: 'change'
  },
  props: {
    companyId: {
      type: [Number, String],
      default: null
    },
    jobLocationList: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.editor',
      vid: 1,
      companyLocationList: [],
      listDialog: {
        show: false,
        selected: []
      },
      editorDialog: {
        location: null,
        show: false
      },
      localJobLocationList: []
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    addI18nName (obj) {
      return addI18nProperty(obj, 'i18nName', 'cn_name', 'name')
    },
    handleDraggableChange () {
      this.$emit('change', this.localJobLocationList)
    },
    handleSelectBtnClick () {
      this.listDialog.show = true
    },
    handleAddBtnClick () {
      this.editorDialog.location = null
      this.editorDialog.show = true
    },
    handleEditBtnClick (location, index) {
      this.editorDialog.location = location
      this.editorDialog.show = true
    },
    handleDeleteBtnClick (location, index) {
      if (this.disabled) {
        return
      }
      if (location.companyLocationId) {
        _.remove(this.listDialog.selected, { id: location.companyLocationId })
      }
      this.jobLocationList.splice(index, 1)
      this.dispatch('ElFormItem', 'el.form.change', [this.jobLocationList])
    },
    handleSelectedLocationChanged (selected) {
      while (this.jobLocationList.length > 0) {
        this.jobLocationList.shift()
      }
      const jobLocationList = _.map(selected, (location) => {
        return {
          _vid: ++this.vid,
          address: location.address,
          city: location.city,
          region: location.region,
          cbd: location.cbd,
          lng: location.lng,
          lat: location.lat,
          companyLocationId: location.id,
          company_job_location_id: location.id
        }
      })
      this.jobLocationList.push(...this.sortLocation(jobLocationList))
      this.dispatch('ElFormItem', 'el.form.change', [this.jobLocationList])
    },
    handleEditLocationChanged (location) {
      const isExisted = _.find(this.jobLocationList, { city: { id: location.city.id }, address: location.address })
      if (isExisted) {
        this.$message.error({ message: this.$t(`${this.i18nPrefix}.message.locationIsExisted`), showClose: true })
        return
      }
      const oldLocation = this.editorDialog.location
      if (oldLocation) {
        oldLocation.city = location.city
        oldLocation.region = location.region
        oldLocation.cbd = location.cbd
        oldLocation.address = location.address
        oldLocation.lng = location.lng
        oldLocation.lat = location.lat
      } else {
        this.jobLocationList.push({
          _vid: ++this.vid,
          ...location,
          company_job_location_id: null,
          companyLocationId: null
        })
        this.dispatch('ElFormItem', 'el.form.change', [this.jobLocationList])
      }
      this.editorDialog.show = false
    },
    sortLocation (jobLocationList) {
      const collator = new Intl.Collator('zh-CN', {
        caseFirst: 'upper'
      })
      return jobLocationList.sort((a, b) => {
        let compare = 0
        compare = collator.compare(a.city?.i18nName, b.city?.i18nName)
        if (compare === 0) {
          compare = collator.compare(a.region?.i18nName, b.region?.i18nName)
        }
        if (compare === 0) {
          compare = collator.compare(a.cbd?.i18nName, b.cbd?.i18nName)
        }
        if (compare === 0) {
          compare = collator.compare(a.address, b.address)
        }
        return compare
      })
    }
  },
  watch: {
    jobLocationList: {
      immediate: true,
      handler () {
        const selected = []
        _.forEach(this.jobLocationList, locationInfo => {
          if (!locationInfo._vid) {
            locationInfo._vid = ++this.vid
          }
          if (!locationInfo.i18nName) {
            this.addI18nName(locationInfo.city)
            this.addI18nName(locationInfo.region)
            this.addI18nName(locationInfo.cbd)
          }
          locationInfo.companyLocationId = locationInfo.company_job_location_id
          selected.push({ id: locationInfo.companyLocationId })
        })
        this.listDialog.selected = selected
        this.localJobLocationList = [...this.jobLocationList]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.job-location-editor {
  .job-location-list {
    padding: 5px 10px 5px 5px;
    border: 1px solid #DCDFE6;

    .ghost {
      opacity: 0.5;
      background: #c8ebfb;
    }

    .job-location {
      display: flex;
      align-items: center;
      padding: 5px;

      &.disabled {
        color: #c0c0c0;
        cursor: not-allowed;

        .draggable-handle {
          cursor: not-allowed;
        }

        .delete-btn {
          cursor: not-allowed;
        }
      }

      .draggable-handle {
        cursor: grab;
        margin-right: 5px;
      }

      .region-cbd {
        margin-left: 10px;
      }

      .address {
        margin-left: 10px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .edit-btn {
        margin-left: 10px;
        cursor: pointer;
      }

      .delete-btn {
        margin-left: 10px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .location-btn-group {
    display: flex;
    justify-content: space-between;

    .location-btn {
      padding: 8px 20px;

      &.select-btn {
        padding-left: 0;
      }

      &.add-btn {
        padding-right: 0;
      }
    }
  }
}
</style>
